<template>

  <div class="h-full w-full" style="background-color: #ccbfa9">
    <div class="flex sm:flex-row flex-col sm:h-full">
      <div class="sm:w-2/3 sm:p-16 p-4">
        <div class="flex-col sm:px-16 justify-center">
          <div class="text-3xl font-light text-black tracking-wide uppercase text-center">Codenames</div>
          <div class="mt-8">
            <div class="mb-4">
              <label class="text-sm pb-1 font-bold">Identifier</label>
              <input
                type="text"
                v-model="seed"
                class="w-full rounded-lg shadow-sm bg-white text-gray-700 px-4 py-2"
              >
            </div>
          <div class="mb-4">
              <label class="text-sm pb-1 font-bold">Are you the spymaster?</label>
              <div class="">

              <span
                @click="isSpymaster = !isSpymaster"
                :class="{ 'bg-gray-200': !isSpymaster, 'bg-green-700': isSpymaster }"
                class="relative inline-block flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:shadow-outline"
              >
                <span
                  :class="{ 'translate-x-5': isSpymaster, 'translate-x-0': !isSpymaster }"
                  class="inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200">

                  </span>
              </span>
            </div>
          </div>
          <div class="">
            <router-link
              :to="{ name: 'game.show', params: { id: seed, isSpymaster: isSpymaster } }"
              class="inline-block bg-black w-full text-center text-white text uppercase rounded-lg shadow-sm px-4 py-4 font-medium"
              >Start game</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="sm:w-1/3 p-16" style="background-color: #b3a48c">
        <div class="">
          <div class="">
            What is codenames?
          </div>
          <div class="text-xs">
            <a href="https://en.wikipedia.org/wiki/Codenames_(board_game)" class="underline">https://en.wikipedia.org/wiki/Codenames_(board_game)</a>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      isSpymaster: false,
      seed: 'abc'
    }
  }
}
</script>

<style>
</style>
